import Model from '../model';
import { sanitize } from 'api/utils';
import { BUY_CARD, GET_AUTH } from 'api/graphql/cards';

const types = {
    customerPhone: String,
    customerName: String,
    customerSurname: String,
    customerEmail: String,
    paymentSystem: String,
    currency: String,
    card: String
}
export const buyCard = async (variables) => {
    return Model.apollo.mutate({
        mutation: BUY_CARD,
        variables: sanitize(variables, types)
    }).then((response) => {
        return processPaymentCardResponse(response);
    });
}

export const processPaymentCardResponse = (response) => {
    if (response['data']?.['createCardPurchase']?.['cardPurchase'] === undefined || response['data']?.['createCardPurchase']?.['cardPurchase'] === null) {
        return {
            error: response['data']?.['error'] || response['data']?.['createCardPurchase']?.['error'] || `no valid response from server, received: ${response}`
        }
    }
    return {
        error: response['data']?.['error'] || response['data']?.['createCardPurchase']?.['error'],
        purchaseId: response['data']?.['createCardPurchase']?.['cardPurchase']?.['id']
    }
}

const authTypes = {
    purchaseId: String
}

export const getAuth = async (variables) => {
    return Model.apollo.mutate({
        mutation: GET_AUTH,
        variables: sanitize(variables, authTypes)
    }).then((response) => {
        return response['data']?.['paymentData']?.['data'];
    });
}
